(function () {
    'use strict';

    angular.module('ib-contact-data-tab-module')
        .controller('ContactDataTabController', ContactDataTabController);

    ContactDataTabController.$inject = ['$scope', 'FlightsPassengersUtils', 'CheckinAppConstants'];
    function ContactDataTabController ($scope, FlightsPassengersUtils, CheckinAppConstants) {
        var vm = this;

        vm.ckeckApisUsTracing = {};
        vm.$onInit = activate;
        vm.updateNextTab = updateNextTab;
        vm.checkUsTracingAPIS = checkUsTracingAPIS;

        ////////////////

        function activate () {
            vm.checkUsTracingAPIS();
        }

        /**
         * Emits an event to complete the next tab
         */
        function updateNextTab () {
            var checksUsTracing = (angular.isDefined(vm.ckeckApisUsTracing.show) && vm.ckeckApisUsTracing.show && angular.isDefined(vm.contactDataModel.confirmEmergencyData) && angular.isDefined(vm.contactDataModel.usPrivacyEmergencyData));

            if (checksUsTracing && vm.contactDataModel.confirmEmergencyData && vm.contactDataModel.usPrivacyEmergencyData) {
                vm.contactDataModel.allTrueInfo = true;
            } else if(checksUsTracing && (!vm.contactDataModel.confirmEmergencyData || !vm.contactDataModel.usPrivacyEmergencyData)) {
                vm.contactDataModel.allTrueInfo = false;
            }
            $scope.$emit('completeNextFormEvent');
        }

        /**
         * Check if exist apis and required emergency data
         */
        function checkUsTracingAPIS () {
            let isRequiredEmergencyData = false;
            let isInfant = false;

            for (let i = 0; i < vm.passengersList.length; i++) {
                const passenger = vm.passengersList[i];
                isInfant = (passenger.basicInfo?.type && passenger.basicInfo.type === CheckinAppConstants.PASSENGER_TYPE.INFANT);
                isRequiredEmergencyData = (!isInfant && !passenger.contactData?.emergencyInfo?.isOptional && passenger.contactData?.emergencyInfo?.isPrivacyStatement);
            }

            vm.ckeckApisUsTracing = FlightsPassengersUtils.initModelApisUsTracing();
            vm.ckeckApisUsTracing = FlightsPassengersUtils.checkExistAPIsUsTracing(vm.ckeckApisUsTracing, isRequiredEmergencyData);
        }
    }
})();